import React, { useMemo } from "react";
import { Table } from "antd";
import { get } from "lodash";
import helpers from "services/helpers";
import { rowClassName } from "utils";
import { useSelector } from "react-redux";
import useTranslation from "hooks/useTranslation";

function OutputTransactions({ data }) {
  const { tr } = useTranslation();
  const outputTransactionsData = useMemo(() => {
    const organizationsWithChildren = get(data, "organizations", []).map(organization => {
      if (get(organization, "categories", []).length > 0) {
        organization.children = get(organization, "categories", []);
      }

      return organization;
    });

    try {
      organizationsWithChildren.unshift({
        name: "Итого",
        total: get(data, "total", 0),
      });
    } catch (error) {
      console.log(error);
    }

    return organizationsWithChildren;
    // No need to check whole data, if some state changes then it will definitely be seen in total
  }, [get(data, "total")]);

  const authStore = useSelector(state => state.auth);
  const defaultCurrency = get(authStore, "default_currency_code");

  return (
    <>
      <Table
        bordered
        size="middle"
        dataSource={outputTransactionsData}
        pagination={false}
        rowClassName={rowClassName()}
        columns={[
          {
            title: tr("Филиалы"),
            dataIndex: "name",
            width: 450,
          },
          {
            title: tr("Сумма"),
            align: "right",
            render(value, record, idx) {
              const total = helpers.convertToReadable(get(record, "total", 0));

              return (
                <>
                  {total} {defaultCurrency.toUpperCase()}
                </>
              );
            },
          },
        ]}
        rowKey={row => row.name}
      />
    </>
  );
}

export default OutputTransactions;
